module.exports = __webpack_public_path__ + "img/hill40.9c4a5a94.jpg";